import React, { useEffect, useState } from 'react';
import styled from './index.module.scss';
import { message } from '@/components/UI/Message';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from 'lowcode/components/EditorImg';
import { SubtractIcon, LockInfoIcon } from '@/components/EcocreditsMonthlyMadness/Svg';
import { ILockInfo } from '@/components/EcocreditsMonthlyMadness/type';
import getLocal from '@/app/utils/getLocal';
import { getProductUrl } from '@/service/vip';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
// import gtm from '@/utils/gtm';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import { signupCookie } from '@/utils/cookies/signupCookie';

const EUProduct: React.FC<{ lockInfo: ILockInfo }> = ({ lockInfo }) => {
    const { t } = useLang('appreciationday');
    const { locale } = getLocal();
    const { asPath } = useRouter();
    const { isLogin, secKillisBegin, secKillProduct } = useMonthlyStore();
    const [isSafari, setIsSafari] = useState(false);

    const list: any[] = secKillProduct.map((item: any) => {
        const newItem = { ...item };
        newItem.disabled = item.inventoryQuantity === 0 || !secKillisBegin;
        newItem.buttonText = t('buy');
        if (newItem.inventoryQuantity > 0) {
            newItem.buttonText = item.checkoutNode ? t('buy') : t('learn_more');
        }
        if (!secKillisBegin) {
            newItem.buttonText = t('exclusive.coming_soon');
        }
        return newItem;
    });

    const handleUnlock = () => {
        // gtm.push({
        //     event: 'uaEvent',
        //     event_name: 'activity_button',
        //     page_name: 'ecocredits-monthly-madness',
        //     list_name: 'Exclusive Flash Sale',
        //     button_name: 'IMG',
        //     function: 'unlock',
        // });
        if (!isLogin) {
            signupCookie?.({
                sector_name: t('exclusive.lock'),
                entry_position: 0,
            });
            location.href = `/${locale}/login?redirect=${encodeURIComponent(`/${locale}/${asPath}#Exclusive_Sale`)}`;
            return;
        }
    };

    const handleDetail = (item: any) => {
        if (item.disabled) return;
        // editorEventsBus.emit('ShopifyCart-add', item);

        // gtm.push({
        //     event: 'uaEvent',
        //     event_name: 'buy',
        //     product_name: item.title,
        //     position: 'Product Preview',
        // });
        getProductUrl(item.id, locale).then((res) => {
            if (res.code !== '0') {
                return message.error(res.message);
            }
            const { purchaseUrl, productUrl } = res.data;
            // toDetail区分点击标题还是购买
            const url = purchaseUrl || productUrl;

            if (isSafari) {
                location.href = url;
            } else {
                try {
                    window.open(url, '_blank');
                } catch {
                    location.href = url;
                }
            }
        });
    };

    useEffect(() => {
        const isSafariCase = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        setIsSafari(isSafariCase);
    }, []);

    return (
        <div className={styled.EUFlashSale}>
            <div className="product_list">
                {list
                    .filter((_item, index) => index < 4)
                    .map((item, ind) => (
                        <div key={item.id} className="item">
                            <div className="top">
                                <EditorImg className="img" pc={item.imageUrl} />
                                <p className="title">{item.title}</p>
                                <p className="subtitle">{item.subtitle1}</p>
                                <p className="subtitle">{item.subtitle2}</p>
                                {item.discount && (
                                    <div className="off">
                                        {item.discount} %<div className="text">{t('off')}</div>
                                    </div>
                                )}
                            </div>
                            <div className="bottom">
                                <p className="price">
                                    <span className="meber">{item.memberPrice2}</span>
                                    {parseInt(item.price) > parseInt(item.memberPrice) ? (
                                        <span className="meberonly">
                                            <span className="text">{t('members.member')}</span>
                                        </span>
                                    ) : (
                                        <span className="compareat">{item.compareAtPrice2}</span>
                                    )}
                                </p>
                                {parseInt(item.price) > parseInt(item.memberPrice) && (
                                    <p className="compareat_price">
                                        <span className="price">{item.price2}</span>
                                        {parseInt(item.compareAtPrice) > parseInt(item.price) && (
                                            <>
                                                <span className="text">&nbsp;&nbsp;({t('non_member_price')})</span>
                                                <span className="compareat">{item.compareAtPrice2}</span>
                                            </>
                                        )}
                                    </p>
                                )}
                                {lockInfo?.unLock && (
                                    <div className="tools">
                                        <EditorLink className={`btn buy_now ${item.disabled ? 'disabled' : ''}`} onClick={() => handleDetail(item)}>
                                            {item.buttonText}
                                        </EditorLink>
                                        <EditorLink className="btn learn_more" href={item.productUrl} target="_blank">
                                            {t('learn_more')}
                                        </EditorLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                {list[4] && (
                    <div className="last_item">
                        <div className="left">
                            <p className="title">{list[4].title}</p>
                            <p className="price">
                                <span className="meber">{list[4].memberPrice2}</span>
                                {parseInt(list[4].price) > parseInt(list[4].memberPrice) ? (
                                    <span className="meberonly">
                                        <span className="text">{t('members.member')}</span>
                                    </span>
                                ) : (
                                    <span className="compareat">{list[4].compareAtPrice2}</span>
                                )}
                            </p>
                            {parseInt(list[4].price) > parseInt(list[4].memberPrice) && (
                                <p className="compareat_price">
                                    <span className="price">{list[4].price2}</span>
                                    {parseInt(list[4].compareAtPrice) > parseInt(list[4].price) && (
                                        <>
                                            <span className="text">({t('non_member_price')})</span>
                                            <span className="compareat">{list[4].compareAtPrice2}</span>
                                        </>
                                    )}
                                </p>
                            )}
                            {lockInfo?.unLock && (
                                <div className="tools">
                                    <EditorLink className={`btn buy_now ${list[4].disabled ? 'disabled' : ''}`} onClick={() => handleDetail(list[4])}>
                                        {list[4].buttonText}
                                    </EditorLink>
                                </div>
                            )}
                        </div>
                        <div className="right">
                            <EditorImg className="img" pc={list[4].imageUrl} />
                        </div>
                    </div>
                )}
                {!lockInfo?.unLock && (
                    <div className="lock" onClick={handleUnlock}>
                        <LockInfoIcon />
                        <p>{t('exclusive.lock')}</p>
                    </div>
                )}
            </div>
            <EditorLink href={`https://${locale}.ecoflow.com/pages/refurbished `} target="_blank" className="link">
                <SubtractIcon />
                {t('exclusive.link_text')}
            </EditorLink>
        </div>
    );
};

export default EUProduct;
